import useQuery from './useQuery';

const Query = ({ children, query }) => {
  const response = useQuery(query);
  return children(response);
};

export default Query;
